//@ts-ignore
import {GetStaticProps} from "next";
import HeaderImageWithHeading from "../../components/common/HeaderImageWithHeading";
import {MarkdownMetaDataInterface} from "../../interfaces/MarkdownMetaDataInterface";
import ContactUsPanel from "../../components/ContactUsPanel/ContactUsPanel";
import {useTranslation} from "next-i18next";
import {RegionInterface} from "../../components/Regions/Regions";
import {useRouter} from "next/router";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";

function Page() {
	const {t} = useTranslation();
	const router = useRouter();
	const regions = t("pages.costaBrava.regions", {
		returnObjects: true,
	}) as RegionInterface[];
	const content = regions.find((r) => r.route === router.asPath);
	return (
		<div className="">
			<HeaderImageWithHeading
				imageSrc={content?.img}
				title={content?.title}
				subtitle={content?.subTitle}
			/>
			<div className="container mx-auto">
				<div className="px-6 md:px-20 my-20">
					<p>{content?.description}</p>
				</div>
				<ContactUsPanel/>
			</div>
		</div>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	return {
		props: {
			...(await serverSideTranslations(context?.locale!, ["common"])),
		},
	};
};

export const REGION_CONTENT_PAGES = [
	{params: {region: "costa-brava"}},
	{params: {region: "empuriabrava"}},
	{params: {region: "rosas"}},
	{params: {region: "st-margarita"}},
	{params: {region: "pau"}},
	{params: {region: "perelada"}},
];

export async function getStaticPaths() {
	return {
		paths: REGION_CONTENT_PAGES,
		fallback: "blocking", // can also be true or 'blocking'
	};
}

export default Page;
